import React from 'react';
import './style.scss';
import { FitStatusDetails } from '../fit-status-details';
import { NeedStatusDetails } from '../need-status-details';

/**
 * TableMainContent component - edited to receive ariaLabel and translation params.
 *
 * @param {Object} props - Props for the TableMainContent component.
 * @param {string} props.title - The title of the content block.
 * @param {string} props.mainContent - The main content of the block.
 * @param {string} props.subContent - The sub content of the block.
 * @param {string} props.mainContentClass - The CSS class for the main content block.
 * @param {string} props.mainContentAriaLabel - The aria-label text for the main content.
 * @param {string} props.subContentAriaLabel - The aria-label text for the sub content.
 * @param {string} props.translationMainContent - The translation key for the main content.
 * @param {string} props.translationSubContent - The translation key for the sub content.
 * @returns {JSX.Element} The TableMainContent component.
 * @example
 *  <TableMainContent
        mainContent={'main content'}
        mainContentAriaLabel={'title'}
        translationMainContent={'translation for title'}
        subContent={'subContent'}
        subContentAriaLabel={'subContent for Arialabel'}
        translationSubContent={'translation for subContent'}
    />
 */
function TableMainContent({ 
    title, 
    upperContent,
    mainContent, 
    subContent, 
    mainContentClass, 
    mainContentAriaLabel, 
    subContentAriaLabel, 
    translationMainContent, 
    translationSubContent,
    fitDetails,
    bottomContent,
}) {
    return (
        <div className="info-content-block">
            {upperContent &&
                <div className="happy-feet-indicator">
                    {upperContent}
                </div>
            }
            <div className="title">
                {title}
            </div>
            <div className={`main-content ${mainContentClass} `}>
                <span tabIndex={0} aria-label={`${translationMainContent} ${mainContentAriaLabel}`}>{mainContent}</span>
                { fitDetails?.fitCount > 0 && <FitStatusDetails fitCount={fitDetails.fitCount} /> }
            </div>
            <div className="sub-content">
                <span tabIndex={0} aria-label={`${translationSubContent} ${subContentAriaLabel}`}>{subContent}</span>
            </div>
            { fitDetails?.logins && <NeedStatusDetails logins={fitDetails.logins} />}
            {bottomContent && <div className="bottom-content">{bottomContent}</div>}
        </div>
    )
};

TableMainContent.defaultProps = {
    title: '', 
    mainContent: '', 
    subContent: '', 
    mainContentClass: '', 
    mainContentAriaLabel: '', 
    subContentAriaLabel: '', 
    translationMainContent: '', 
    translationSubContent: '',
    bottomContent: null
};

export default TableMainContent;